import axios from 'axios'
import swal from 'sweetalert'
import { createApp } from 'vue'

if (document.getElementById('blog')) {
  const app = createApp({
    data() {
      return {
        limit: 6,
        hasMorePosts: true,
        posts: window.culligan.blogPosts || [],
        queryVars: window.culligan.queryVars || {}
      }
    },
    computed: {
      offset() {
        return this.posts.length
      },
      featuredPost() {
        if (this.posts.length) {
          return this.posts[0]
        }
      },
      latestPosts() {
        if (this.posts.length > 1) {
          return this.posts.slice(1, 3)
        }
      },
      otherPosts() {
        if (this.posts.length > 3) {
          return this.posts.slice(3)
        }
      }
    },
    mounted() {
      if (this.posts.length <= this.limit) {
        this.hasMorePosts = false
      }
    },
    methods: {
      loadMoreBlogPosts(e) {
        let button = e.target
        let buttonText = button.textContent || button.innerText
        button.disabled = true
        button.textContent = 'Loading...'

        const params = new URLSearchParams()
        params.append('action', 'load_more_blog_posts')
        params.append('offset', this.offset)
        params.append('limit', this.limit)
        params.append('query', JSON.stringify(this.queryVars))

        axios.post(ajaxurl, params)
          .then((response) => {
            if (response.data.posts) {
              let posts = JSON.parse(response.data.posts)
              if (posts.length) {
                this.posts = this.posts.concat(posts)
              } else {
                this.hasMorePosts = false
              }
            }
          })
          .catch(() => {
            swal('', 'An unknown error occurred.', 'error')
          })
          .then(() => {
            button.disabled = false
            button.textContent = buttonText
          })
      }
    }
  })

  app.mount('#blog')
}
